var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAndroidIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "white",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M520 5106 c-115 -32 -215 -109 -274 -209 -70 -119 -66 38 -66 -2339 0 -1877 2 -2151 15 -2207 59 -248 306 -399 550 -336 64 17 36 2 2010 1083 627 343 1331 728 1564 855 362 198 433 240 482 288 180 178 179 464 -1 639 -49 47 -159 111 -791 456 -404 221 -1283 703 -1954 1070 -671 368 -1249 679 -1285 691 -74 26 -177 29 -250 9z m1704 -1062 c726 -398 1321 -728 1321 -732 0 -5 -134 -138 -298 -296 l-298 -289 -31 29 c-104 96 -2168 2086 -2168 2090 0 3 34 -14 76 -37 42 -23 671 -367 1398 -765z m-609 -371 c633 -609 1150 -1110 1150 -1113 0 -11 -2300 -2220 -2309 -2217 -36 12 -36 18 -34 2231 3 2163 4 2206 35 2206 5 0 526 -498 1158 -1107z m2610 -723 c204 -112 382 -211 397 -221 38 -28 78 -113 78 -169 0 -55 -41 -143 -78 -168 -14 -9 -210 -119 -436 -243 l-411 -225 -325 313 c-179 173 -325 318 -325 323 0 5 146 151 325 323 l325 314 40 -22 c22 -13 207 -114 410 -225z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidIcon);
export default __webpack_public_path__ + "static/media/android-icon.451cd711862a13c8ed9c42eb4af4fcea.svg";
export { ForwardRef as ReactComponent };